import {
  Box,
  CircularProgress
} from "@material-ui/core";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouteMatch } from "react-router-dom";
import Sidebar from "../../../common/Sidebar";
import CustomErrorAlert from "../../../components/Common/CustomErrorAlert";
import ButtonAppBar from "../../../components/Main/ButtonAppBar";
import { userDrawerList } from "../../../constants";
import {
  getCurrentUserId,
  getRolePermisionRoutes,
  isAdminLogin,
  isSuperAdminLogin,
} from "../../../utils";
import * as dashboardActions from "../Dashboard/actions";
// import CircularProgress from '../../../assets/icons/ship.gif'
function UserMain(props) {
  const { routeName = "" } = props;
  const dispatch = useDispatch();
  const [openDrawer, setOpenDrawer] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [loadingMsg, setlLoadingMsg] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const {
    errorList = [],
    errorTitle = "",
    errorOpen = false,
  } = useSelector((state) => state.common);
  const routeMatch = useRouteMatch();

  useEffect(() => {
    const organizationAdmin = isAdminLogin()
      ? { organizationAdmin: getCurrentUserId() }
      : {};
    dispatch(dashboardActions.getAllOrganizations(organizationAdmin));
  }, [dispatch]);

  const onClickMenu = () => {
    setOpenDrawer(!openDrawer);
  };

  const onSetLoader = (action, loadingMessage = null) => {
    setLoader(action);
    if (loadingMessage) setlLoadingMsg(loadingMessage);
  };

  const validRoutes = userDrawerList.filter((item) => {
    return getRolePermisionRoutes().includes(item.url.split("?")[0]);
  });

  useEffect(() => {
    if (
      routeName !== "Matrix" &&
      routeName !== "Saved Results" &&
      routeName !== "Estimation analysis" &&
      routeName !== "Cargo Vessel Estimation" &&
      routeName !== "Cargo Cargo Estimation" &&
      routeName !== "Vessel Vessel Estimation" &&
      routeName !== "Cargo Analysis Estimation" &&
      routeName !== "Vessel Vessel Contracts" &&
      routeName !== "Cargo Cargo Contracts" &&
      routeName !== "Message Box" &&
      routeName !== "Saved Operation Results" &&
      routeName !== "Operation Calculator" &&
      routeName !== "Cargo Vessel Operations" &&
      routeName !== "Cargo Cargo Calculator" &&
      routeName !== "Cargo Cargo Operations" &&
      routeName !== "Vessel Vessel Calculator" &&
      routeName !== "Vessel Vessel Operations" &&
      routeName !== "Operation Estimate" &&
      routeName !== "Estimation Analysis" &&
      routeName !== "Distance Estimation" &&
      routeName !== "Port Information"
    ) {
      setIsFullScreen(false);
    }
  }, [routeName]);

  return (
    <div className="root-main-theme w-full max-w-full overflow-x-hidden">
      {loader ? (
        <div className="main-advanced-loader">
          <div className="loader-wrapper">
            {/* <img className="loader-wrapper-ship-img" src={CircularProgress} size={45} /> */}
            <CircularProgress />
            {loadingMsg ? (
              <div>
                <p className="text-base">{loadingMsg}</p>
              </div>
            ) : null}
          </div>
        </div>
      ) : null}
      <Sidebar
        isMobile={true}
        drawerOpen={openDrawer}
        setDrawerOpen={setOpenDrawer}
        drawerClose={onClickMenu}
        validRoutes={validRoutes}
        activeRoute={routeMatch.path + (props.location?.search || "")}
      />{" "}
      <div
        className={clsx(
          "flex bg-lightGray2 main-body overflow-x-hidden w-full max-w-full",
          isFullScreen ? "h-screen max-h-screen overflow-hidden" : "min-h-screen"
        )}
      >
        <span className="sidebar-main z-[999]">
          <Sidebar
            drawerOpen={drawerOpen}
            drawerClose={() => setDrawerOpen((s) => !s)}
            validRoutes={validRoutes}
            setDrawerOpen={setDrawerOpen}
            activeRoute={routeMatch.path + (props.location?.search || "")}
          /></span>
        <div
          className={clsx(
            "flex flex-col main-content-wrapper min-w-0 flex-1 transition-all duration-200 overflow-x-hidden max-w-full",
            isFullScreen ? "h-screen max-h-screen overflow-y-auto" : "min-h-screen",
            {
              "drawer-open": drawerOpen,
            }
          )}
        >
          {/* {routeName !== "Matrix" && ( */}
          <ButtonAppBar
            onClickMenu={onClickMenu}
            title={routeName}
            validRoutes={validRoutes}
            activeRoute={routeMatch.path + (props.location?.search || "")}
          />
          {/* )}  */}
          <Box
            className={clsx("flex-1 min-w-0 max-w-full overflow-x-hidden", {
              "superadmin-panel": isSuperAdminLogin(),
              "px-4 md:px-5 py-2.5 overflow-x-clip": !isFullScreen,
              "h-full overflow-y-auto flex flex-col": isFullScreen,
            })}
          >
            {React.cloneElement(props.children, {
              setLoader: onSetLoader,
              setIsFullScreen,
              loader,
            })}
          </Box>
        </div>
      </div>
      {/* <Grid container className="main-parent-container">
        <Grid item xs={12} style={{ height: "calc(100vh - 50px)" }}></Grid>
      </Grid> */}
      {errorOpen ? (
        <CustomErrorAlert errorList={errorList} errorTitle={errorTitle} />
      ) : null}
    </div>
  );
}

export default UserMain;
